var _clipPath, _pattern;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCanvaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial0",
    gradientUnits: "userSpaceOnUse",
    cx: 0,
    cy: 0,
    fx: 0,
    fy: 0,
    r: 1,
    gradientTransform: "matrix(10.063026,-11.747371,11.747371,10.063026,3.857383,17.726262)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(39.215686%,12.54902%,100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(39.215686%,12.54902%,100%)",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial1",
    gradientUnits: "userSpaceOnUse",
    cx: 0,
    cy: 0,
    fx: 0,
    fy: 0,
    r: 1,
    gradientTransform: "matrix(10.079056,14.236742,-14.236742,10.079056,5.294972,2.283765)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(0%,76.862745%,80%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(0%,76.862745%,80%)",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial2",
    gradientUnits: "userSpaceOnUse",
    cx: 0,
    cy: 0,
    fx: 0,
    fy: 0,
    r: 1,
    gradientTransform: "matrix(10.7684,-10.842,4.9864,4.9526,3.86,17.72)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(39.215686%,12.54902%,100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(39.215686%,12.54902%,100%)",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial3",
    gradientUnits: "userSpaceOnUse",
    cx: 0,
    cy: 0,
    fx: 0,
    fy: 0,
    r: 1,
    gradientTransform: "matrix(6.2736,14.442,-24.193599,10.5098,8.18,2.7)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(0%,76.862745%,80%)",
      stopOpacity: 0.72549
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(0%,76.862745%,80%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(0%,76.862745%,80%)",
      stopOpacity: 0
    }
  })), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface5",
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 20,
    height: 20,
    style: {
      fill: "rgb(49.019608%,16.470589%,90.588236%)",
      fillOpacity: 1,
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 20,
    height: 20,
    style: {
      fill: "url(#radial0)",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 20,
    height: 20,
    style: {
      fill: "url(#radial1)",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 20,
    height: 20,
    style: {
      fill: "url(#radial2)",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 20,
    height: 20,
    style: {
      fill: "url(#radial3)",
      stroke: "none"
    }
  })), _pattern || (_pattern = /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternUnits: "userSpaceOnUse",
    width: 20,
    height: 20
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#pattern0)"
    },
    d: "M 20 10 C 20 4.476562 15.523438 0 10 0 C 4.476562 0 0 4.476562 0 10 C 0 15.523438 4.476562 20 10 20 C 15.523438 20 20 15.523438 20 10 Z M 20 10 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 17.890625 10.433594 C 17.863281 10.433594 17.839844 10.453125 17.828125 10.488281 C 17.667969 10.945312 17.449219 11.21875 17.269531 11.21875 C 17.167969 11.21875 17.128906 11.105469 17.128906 10.925781 C 17.128906 10.476562 17.398438 9.523438 17.53125 9.089844 C 17.546875 9.046875 17.554688 9 17.558594 8.949219 C 17.558594 8.824219 17.488281 8.761719 17.316406 8.761719 C 17.148438 8.761719 16.933594 8.835938 16.742188 9.171875 C 16.675781 8.875 16.476562 8.746094 16.191406 8.746094 C 15.867188 8.746094 15.554688 8.953125 15.296875 9.292969 C 15.035156 9.632812 14.734375 9.742188 14.503906 9.6875 C 14.667969 9.285156 14.730469 8.984375 14.730469 8.761719 C 14.730469 8.410156 14.558594 8.199219 14.277344 8.199219 C 13.851562 8.199219 13.605469 8.605469 13.605469 9.03125 C 13.605469 9.363281 13.757812 9.703125 14.085938 9.867188 C 13.8125 10.492188 13.40625 11.054688 13.253906 11.054688 C 13.058594 11.054688 13 10.089844 13.011719 9.398438 C 13.015625 9 13.050781 8.980469 13.050781 8.859375 C 13.050781 8.792969 13.003906 8.746094 12.824219 8.746094 C 12.410156 8.746094 12.277344 9.097656 12.257812 9.507812 C 12.253906 9.660156 12.226562 9.8125 12.1875 9.960938 C 12.011719 10.585938 11.652344 11.058594 11.417969 11.058594 C 11.308594 11.058594 11.277344 10.949219 11.277344 10.808594 C 11.277344 10.359375 11.53125 9.796875 11.53125 9.320312 C 11.53125 8.96875 11.375 8.746094 11.085938 8.746094 C 10.742188 8.746094 10.289062 9.152344 9.859375 9.914062 C 10.003906 9.332031 10.058594 8.765625 9.644531 8.765625 C 9.550781 8.765625 9.464844 8.789062 9.382812 8.832031 C 9.328125 8.859375 9.296875 8.914062 9.300781 8.976562 C 9.339844 9.597656 8.796875 11.191406 8.285156 11.191406 C 8.191406 11.191406 8.144531 11.089844 8.144531 10.925781 C 8.144531 10.476562 8.414062 9.527344 8.546875 9.09375 C 8.5625 9.046875 8.574219 8.996094 8.574219 8.945312 C 8.574219 8.828125 8.5 8.765625 8.335938 8.765625 C 8.152344 8.765625 7.953125 8.835938 7.761719 9.171875 C 7.691406 8.875 7.492188 8.746094 7.210938 8.746094 C 6.75 8.746094 6.234375 9.230469 6.007812 9.871094 C 5.703125 10.71875 5.09375 11.539062 4.269531 11.539062 C 3.523438 11.539062 3.128906 10.917969 3.128906 9.9375 C 3.128906 8.519531 4.171875 7.363281 4.941406 7.363281 C 5.3125 7.363281 5.488281 7.597656 5.488281 7.957031 C 5.488281 8.394531 5.242188 8.59375 5.242188 8.761719 C 5.242188 8.8125 5.285156 8.863281 5.371094 8.863281 C 5.707031 8.863281 6.097656 8.46875 6.097656 7.929688 C 6.097656 7.394531 5.664062 7 4.890625 7 C 3.617188 7 2.332031 8.285156 2.332031 9.925781 C 2.332031 11.234375 2.980469 12.023438 4.09375 12.023438 C 4.855469 12.023438 5.519531 11.433594 5.882812 10.742188 C 5.921875 11.316406 6.179688 11.613281 6.578125 11.613281 C 6.929688 11.613281 7.214844 11.402344 7.433594 11.035156 C 7.515625 11.421875 7.738281 11.609375 8.027344 11.609375 C 8.359375 11.609375 8.636719 11.398438 8.898438 11.011719 C 8.894531 11.316406 8.964844 11.605469 9.230469 11.605469 C 9.359375 11.605469 9.507812 11.574219 9.535156 11.464844 C 9.8125 10.308594 10.503906 9.367188 10.714844 9.367188 C 10.777344 9.367188 10.796875 9.425781 10.796875 9.496094 C 10.796875 9.8125 10.574219 10.453125 10.574219 10.867188 C 10.574219 11.3125 10.761719 11.605469 11.152344 11.605469 C 11.585938 11.605469 12.023438 11.074219 12.316406 10.300781 C 12.410156 11.023438 12.609375 11.605469 12.917969 11.605469 C 13.296875 11.605469 13.976562 10.804688 14.382812 9.957031 C 14.542969 9.976562 14.785156 9.972656 15.015625 9.808594 C 14.917969 10.0625 14.863281 10.332031 14.863281 10.605469 C 14.863281 11.394531 15.238281 11.613281 15.558594 11.613281 C 15.914062 11.613281 16.199219 11.402344 16.417969 11.035156 C 16.488281 11.367188 16.671875 11.609375 17.011719 11.609375 C 17.539062 11.609375 18 11.066406 18 10.625 C 18 10.507812 17.949219 10.433594 17.890625 10.433594 Z M 6.902344 11.175781 C 6.6875 11.175781 6.601562 10.960938 6.601562 10.640625 C 6.601562 10.082031 6.984375 9.152344 7.386719 9.152344 C 7.5625 9.152344 7.628906 9.359375 7.628906 9.613281 C 7.628906 10.179688 7.269531 11.175781 6.902344 11.175781 Z M 14.226562 9.511719 C 14.097656 9.359375 14.050781 9.152344 14.050781 8.96875 C 14.050781 8.742188 14.132812 8.550781 14.234375 8.550781 C 14.335938 8.550781 14.363281 8.648438 14.363281 8.785156 C 14.363281 9.011719 14.28125 9.347656 14.226562 9.511719 Z M 15.882812 11.175781 C 15.667969 11.175781 15.585938 10.929688 15.585938 10.640625 C 15.585938 10.101562 15.96875 9.152344 16.375 9.152344 C 16.550781 9.152344 16.613281 9.355469 16.613281 9.613281 C 16.613281 10.179688 16.257812 11.175781 15.882812 11.175781 Z M 15.882812 11.175781 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanvaLogo);
export default __webpack_public_path__ + "static/media/canva_logo.9dd7f0530af955f0cf91551fca9596d7.svg";
export { ForwardRef as ReactComponent };